<template>
  <el-select
    v-model="model.provider"
    filterable
    remote
    reserve-keyword
    :disabled="disabled"
    clearable
    value-key="id"
    :remote-method="fetchSearchedProviders"
    :loading="loading"
    :placeholder="myPlaceHolder"
    @change="selectProvider">
    <el-option
      v-for="provider in searchedProviders"
      :key="provider.id"
      :label="provider.name"
      :value="provider">
      <span style="margin-left:5px; color: #8492a6; font-size: 13px">{{ provider.name }}</span>
    </el-option>
  </el-select>
</template>
<script>
import cmsAPI from '@/services/API/cmsAPI'
import { mapActions, mapState, mapGetters } from 'vuex';
export default {
	name: 'SelectCMSProvider',
  props: {
		provider : {
      type : Object
    },
    active : {
      type : Boolean,
      default : true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder : {
      type: String,
      default: null,
    }
	},
	data() {
		return {
      model : {
        provider : null
      },
      searchedProviders : [],
      loading : false
	   }
   },
  computed: {
    myPlaceHolder(){
      if (this.placeholder == null) {
        return this.$i18n.t('common.select.placeholder');
      }
      return this.placeholder;
    }
  },
  components : {
  },
  methods : {
    selectProvider(provider){
      this.$emit('selected', provider);
    },
    fetchSearchedProviders(query){
      this.loading = true;
      return cmsAPI.fetchCMSProviders({t:query,paging:'no', active:this.active})
      .then(searchedProviders => {
        this.searchedProviders = searchedProviders;
        this.loading = false;
      });
    },
    getCMSProviderById(providerId){
      return cmsAPI.getCMSProvider(providerId)
    }
  },
  watch: {
    provider: function(newProvider, oldProvider) {
      if (newProvider == null) {
        this.model.provider = null;
        this.searchedProviders = [];
      } else {
        this.searchedProviders = [newProvider];
        this.model.provider = newProvider;
      }

    }
  },
  created(){
    if(this.provider!=null){
      this.getCMSProviderById(this.provider.id)
        .then(provider=>{
          this.searchedProviders.push(provider);
          this.model.provider = provider;
          this.selectProvider(provider)
        })
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
